module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img-2.33e7a260.jpeg";